import { useState } from "react";
import { CalendarDays } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";

export const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
export const YEARS = Array.from({ length: new Date().getFullYear() - 2019 }, (_, i) => new Date().getFullYear() - i);

// Clickable period label that opens a Year/Month "Jump to" picker; onPick receives a Date.
export const PeriodJumpPicker = ({ period, anchor, label, onPick, testIdPrefix = "sales" }) => {
  const [open, setOpen] = useState(false);
  const years = [...new Set([...YEARS, anchor.getFullYear()])].sort((a, b) => b - a);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="sm" className="font-semibold min-w-[150px]" data-testid={`${testIdPrefix}-period-label`}>
          <CalendarDays className="h-4 w-4 mr-1.5" /> {label}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-64 bg-white space-y-3" data-testid={`${testIdPrefix}-period-jump`}>
        <p className="text-xs font-medium text-gray-600">Jump to</p>
        <Select value={String(anchor.getFullYear())} onValueChange={(v) => onPick(new Date(Number(v), anchor.getMonth(), 1))}>
          <SelectTrigger data-testid={`${testIdPrefix}-jump-year`}><SelectValue /></SelectTrigger>
          <SelectContent>{years.map((y) => <SelectItem key={y} value={String(y)}>{y}</SelectItem>)}</SelectContent>
        </Select>
        {period !== "year" && (
          <Select value={String(anchor.getMonth())} onValueChange={(v) => { onPick(new Date(anchor.getFullYear(), Number(v), 1)); setOpen(false); }}>
            <SelectTrigger data-testid={`${testIdPrefix}-jump-month`}><SelectValue /></SelectTrigger>
            <SelectContent>{MONTHS.map((m, i) => <SelectItem key={m} value={String(i)}>{m}</SelectItem>)}</SelectContent>
          </Select>
        )}
      </PopoverContent>
    </Popover>
  );
};
